import type { AuthorizationType } from '@shared/core-types';

import type { ORDER_FORM } from './PaymentOrderConstants';
import type { ORDER_TYPE } from '../Payments';

export enum BUNDLE_ORDER_TYPE {
    DOMESTIC = 'DOMESTIC',
    SEPA = 'SEPA',
    INTERNATIONAL = 'INTERNATIONAL',
    DATACARRIER = 'DATACARRIER',
    DIRECT_DEBIT = 'DIRECT_DEBIT',
    UNKNOWN = 'UNKNOWN',
    DOMESTIC_COLLECTIVE_SIGNING = 'DOMESTIC_COLLECTIVE_SIGNING',
    DOMESTIC_COLLECTIVE_SIGNING_OPN = 'DOMESTIC_COLLECTIVE_SIGNING_OPN',
    OWN_FX = 'OWN_FX',
    OWN_TRANSFER = 'OWN_TRANSFER',
    BULK = 'BULK',
}

export interface CountryBundleConfig {
    [authorizationType: string]: BundleConfig[];
}

export interface BundleConfig {
    combination: BUNDLE_ORDER_TYPE[];
    maxSize: number;
    mixOrderAndSenderAccountCurrencyAllowed: boolean;
    mixCurrenciesAllowed: boolean;
    mixSenderAccountsAllowed: boolean;
    mixDifferentCurrencySenderAccounts: boolean;
    authorizationType?: AuthorizationType;
    allowedCurrencies?: string[];
    forbiddenOrderForms?: ORDER_FORM[];
    allowedOrderTypes?: ORDER_TYPE[];
    forbiddenOrderTypes?: ORDER_TYPE[];
}
